Apt.fn.make('tabs', {
	/**
	 * Initialize module
	 */
	init: function() {
		var scope = this,
			$tabs = $$('tabs').find('a'),
			visibleClass = '-is-visible',
			activeClass = '-is-active';

		$tabs.unbind()
			.on('click.tabs', function(e, el) {
				var $tab = $(el),
					target = $tab.attr('href');

				$tabs.removeClass(activeClass);
				$tab.addClass(activeClass);

				if (target[0] === '#') {
					$$('tabbed').children(target)
						.addClass(visibleClass)
						.siblings()
						.removeClass(visibleClass);
				}

				e.preventDefault();
			});

		$($._win).on('hashchange', function() {
			scope.$private.parseHash();
		}, {
			init: true
		});
	},

	/**
	 * Unload module
	 */
	unload: function() {
		$.events.reset('tabs');
	}
}, {
	/**
	 * Parse hash for tab activation
	 */
	parseHash: function() {
		var hash = $.routes.uri().hash;

		if (! hash) {
			return;
		}

		var $tab = $$('tabs')
			.find('a')
			.filter('[href="#' + hash + '"]');

		if ($tab.length) {
			$tab.trigger('click');

			requestAnimationFrame(function() {
				$tab[0].scrollIntoView();
			});
		}
	}
});